<template>
    <div class="gmf-dm-conversation-list">
        <div
            v-for="convo in conversations"
            :key="convo.customer.id"
            class="gmf-dm-conversation-list-row"
            :class="{
                'gmf-dm-conversation-list-row-unread': convo.unreadCount > 0,
            }"
            @click.stop.prevent="openConversation(convo.customer.id)"
        >
            <Avatar :customer="convo.customer" />
            <div class="gmf-dm-conversation-list-row-content">
                <div class="gmf-subheader">{{ convo.customer.name }}</div>
                <div class="gmf-dm-conversation-list-row-message">{{ convo.lastMessage }}</div>
                <div class="gmf-text-small">{{ timeAgo(convo.lastMessageAt) }}</div>
            </div>
            <div class="gmf-dm-conversation-list-row-unread-count" v-if="convo.unreadCount > 0">{{ convo.unreadCount }}</div>
        </div>
        <div v-if="conversations.length === 0" class="gmf-text-small">{{ t('direct_messages.no_conversations') }}</div>
    </div>
</template>

<style>
.gmf-dm-conversation-list {
    display: flex;
    flex-direction: column;
    gap: var(--gmf-p-2);
}
.gmf-dm-conversation-list-row {
    display: flex;
    gap: var(--gmf-p-3);
    align-items: center;
    cursor: pointer;
    padding: var(--gmf-p-3);
}
.gmf-dm-conversation-list-row:hover {
    background: var(--gmf-col-lightgray);
    border-radius: var(--gmf-rounding);
}
.gmf-dm-conversation-list-row:hover .gmf-dm-conversation-list-row-message {
    text-decoration: underline;
}
.gmf-dm-conversation-list-row .gmf-avatar {
    width: 64px;
    height: 64px;
    flex-shrink: 0;
}
.gmf-dm-conversation-list-row-content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    gap: var(--gmf-p-1);
    flex-grow: 1;
}
.gmf-dm-conversation-list-row .gmf-subheader {
    margin: 0;
}
.gmf-dm-conversation-list-row-message {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.gmf-dm-conversation-list-row-unread .gmf-dm-conversation-list-row-message  {
    font-weight: bold;
    color: var(--gmf-col-black);
}

.gmf-context .gmf-dm-conversation-list-row-unread-count {
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: var(--gmf-notification-color);
    color: var(--gmf-col-white);
    flex-shrink: 0;
    justify-self: flex-end;
    vertical-align: center;
    border-radius: 99px;
    font-weight: bold;
    font-size: 12px;
}
</style>

<script>
import callApi from '@/utils/callApi';
import Avatar from '@/components/Avatar.vue';
import openConversation from '@/components/DirectMessages/openConversation';

import timeAgo from '@/utils/timeAgo';
import state from '@/state';

export default {
    data() {
        return {
            conversations: [],
            loadInterval: null,
        };
    },
    mounted() {
        this.load();
        this.loadInterval = setInterval(this.loadIfVisible, 4000);
    },
    unmounted () {
        clearInterval(this.loadInterval);
    },
    methods: {
        t: state.t,
        openConversation (customerId) {
            openConversation(customerId);
        },
        timeAgo (date) {
            let d = new Date(date);
            return timeAgo(d.getTime()/1000);
        },
        loadIfVisible () {
            if (document.visibilityState === 'hidden') {
                return;
            }
            this.load();
        },
        async load() {
            const res = await callApi('GET', '/v1/client/dm/conversations');
            const { conversations } = await res.json();
            this.conversations = conversations;
        },
    },
    components: { Avatar }
};
</script>